<template>
  <v-container fluid class="app">
    <div class="absolute-center white--text">
      <v-icon style="font-size: 10vmax" class="mt-8 white--text">
        {{ icone }}
      </v-icon>
      <v-divider class="secondary mt-7"></v-divider>
      <h3 class="mt-4">{{ nomeDoErro }}</h3>
      <p class="mt-5">{{ mensagemDeErro }}</p>
    </div>
  </v-container>
</template>

<script>
export default {
  props: {
    icone: { type: String },
    nomeDoErro: { type: String },
    mensagemDeErro: { type: String },
  },
  components: {},
}
</script>
<style>
.app {
  background: rgba(0, 86, 185, 1);
  height: 100%;
}
.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
</style>
